import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Delete from '../../../../Assets/img/svg/delete.svg';
import del from "../../../../Assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../Assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField"

class MasterData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            render: false,
            dataList: [],
            deleteId: 0,
            showrow: false,
            responseId: 0,
            index: 0,
            actNameFocus: false,
            DescNameFocus: false,
            name: "",
            description: "",
            nameError: false,
            searchData: {
                Name: "",
                PageNumber: 1,
                PageSize: 100,
            },
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.dataTable(this.state.searchData, "Operation")
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    dataTable = (data, type) => {
        let apiUrl = API.LOOKUP_DATA + '?Name=' + data.Name + '&Type=' + type + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    response.data.Values.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.state.dataList = response.data;
                    this.state.dataList.Values.push({
                        Id: 0,
                        Name: "",
                        Description: "",
                        Type: "Operation"
                    })
                    this.state.render = true;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MASDATA0 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData0 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#MasterData00").addClass("d-none");
        $("#MasterData00").removeClass("d-block");
        $("#MOPA").removeClass("active-color");
        $("#MOPAT").removeClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebarmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MASDATA0 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData0 .MuiListItemText-primary").addClass("fw-bolder");
        $("#MasterData00").removeClass("d-none");
        $("#MasterData00").addClass("d-block");
        $("#MOPAT .MuiListItemText-primary").addClass("fw-bolder")
        $("#MOPA").addClass("active-color")
    };

    post_data = (data) => {
        let apiUrl = API.LOOKUP_DATA;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataList.Values.map((i) => (
                        i.Id == 0 ? i.Id = response.data : <></>
                    ))
                    this.setState({})
                    this.state.showrow = false;
                    this.state.actNameFocus = false;
                    this.state.nameError = false;
                    this.state.index = response.data
                    document.getElementById("actName" + response.data).focus()
                    let id = this.state.dataList.Values.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList.Values.push({
                            Id: 0,
                            Name: "",
                            Description: "",
                            Type: "Operation"
                        })
                    }
                    this.state.dataList.Values.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/' + data.Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.actNameFocus = false;
                    this.state.DescNameFocus = false;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.deleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.deleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/ids?' + 'ids=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let data = {
                        Name: "",
                        PageNumber: 1,
                        PageSize: 100,
                    };
                    this.dataTable(data, "Operation")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    handleInputChange1 = (e, str, val, index) => {
        if (val == "Name") {
            this.state?.dataList?.Values.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value : <></>
            ))
            let data = {
                Id: 0,
                Name: e.target.value.trim(),
                Description: this.state.description.trim(),
                Type: "Operation"
            }
            if (e.target.value.trim() == "" && str.Id != 0) {
                this.state.index = str.Id;
                document.getElementById("actName" + str.Id).focus();
            }
            if (str.Id == 0 && e.target.value.length == 1 && e.target.value.trim() != "") {
                this.post_data(data)
                this.state.actNameFocus = true;
            }
            if (str.Id == 0 && str.Name.trim() != "") {
                this.state.showrow = true;
                this.state.nameError = true;
                this.setState({})
            }
        }
        if (val == "Description") {
            this.state?.dataList?.Values.map((i) => (
                i.Id == str.Id ? i.Description = e.target.value : <></>
            ))
        }
        this.setState({})
    }

    handlePasteChange = (event, str, val, index) => {
        let data = {
            Id: 0,
            Name: event.clipboardData.getData("text").trim(),
            Description: str.Description.trim(),
            Type: "Operation"
        }
        this.state?.dataList?.Values.map((i) => (
            i.Id == 0 ? i.Name.trim() == "" ? (
                this.post_data(data),
                this.state.actNameFocus = true
            )
                : "" : ""
        ))
        this.setState({})
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.dataTable(this.state.searchData, "Operation")
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.dataTable(this.state.searchData, "Operation")
    }

    handleInputChange = (e, str, val) => {
        if (val == "Name") {
            if (str.Name != "") {
                str.Name = e.target.value.trim();
                this.put_data(str)
                this.state.actNameFocus = false;
                this.state.DescNameFocus = false;
            }
            if (str.Name.trim() == "") {
                this.deleteopalookdocs(str.Id)
                this.state.index = 0;
            }
        }
        if (val == "Description") {
            str.Description = e.target.value.trim();
            this.put_data(str)
            this.state.DescNameFocus = false;
        }
        this.state.dataList.Values.sort((a, b) => {
            return a.Id - b.Id;
        });
        this.setState({})
        this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
    }

    postDataChange = (e, val) => {
        if (val == "Name") {
            this.state.name = e.target.value;
            if (e.target.value.trim() != "") {
                this.state.showrow = true;
            }
            if (e.target.value.trim() != "") {
                this.state.nameError = true;
            }
        }
        if (val == "Description") {
            this.state.description = e.target.value;
        }
        this.setState({})
    }

    postDataBlur = (e, str, val) => {
        if (val == "Name") {
            if (e.target.value.trim() != "") {
                document.getElementById("DescName").blur();
                this.state.showrow = false;
                this.state.nameError = false;
                let data = {
                    Id: str.Id,
                    Name: e.target.value.trim(),
                    Description: str.Description.trim(),
                    Type: "Operation"
                }
                this.put_data(data)
                this.state.actNameFocus = false;
                this.state.dataList.Values.sort((a, b) => {
                    return a.Id - b.Id;
                });
                this.setState({})
            }
            if (e.target.value.trim() == "") {
                this.state.dataList.Values.map((i) => (
                    i.Id == 0 ? (
                        i.Id = 0,
                        i.Name = "",
                        i.Description = "",
                        i.Type = "Operation"
                    ) : ""
                ))
                this.state.showrow = false;
                this.state.nameError = false;
                this.state.name = "";
                this.state.description = "";
                this.setState({})
            }
        }
        if (val == "Description") {
            let data = {
                Id: str.Id,
                Name: e.target.value.trim(),
                Description: str.Description.trim(),
                Type: "Operation"
            }
            this.put_data(data)
        }
        this.setState({})
    }

    hoverHeight = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }
        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.FocusId = i.Id;
        if (data > data1) {
            this.state.Rows1 = data + 1;
        }
        else {
            this.state.Rows1 = data1 + 1;
        }
        this.setState({})
    }

    handleFocusDescription = (e, str, val) => {
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('DescName').selectionStart = e.target.value.trim().length;
            document.getElementById('DescName').focus()
        }
    }

    handleFocusDescription1 = (e, str, val) => {
        if (e.target.value.trim().length > 0) {
            document.getElementById('DescName' + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById('DescName' + str.Id).focus()
        }
    }

    handleFocusNameChange = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById("actName" + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById("actName" + str.Id).focus()
        }
    }

    handleFocusActChange = (e, str, val) => {
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('actName').selectionStart = e.target.value.trim().length;
            document.getElementById('actName').focus()
        }
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
             {/*    {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="MASDATA0" className='  textNaviIcon' primary="Master Data" />
                                            <NavigateNextIcon id="MASDATA00" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Operation Planning & Achievement</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto mt-138" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Operation Planning & Achievement</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Activity Name</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Description</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList.Values && this.state?.dataList.Values.map((i, index) => (
                                            i.Id != 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        {/* <div className={(this.state.HoverId == i.Id || this.state.index == i.Id) ? "border-top border-bottom border-left border-right" : ""}> */}
                                                        {/* {(i.Name == "") ?
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    autoFocus={this.state.index == i.Id ? true : false}
                                                                    id={"actName" + i.Id}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                    style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                                                    onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                    onChange={(e) => this.handleInputChange1(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.handleInputChange(e, i, 'Name')}
                                                                    value={i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} /> : */}
                                                        {/* <div className={(this.state.HoverId == i.Id || this.state.index == i.Id) ? "border-bg" : "border-bg-none"}>
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                // className={(this.state.HoverId == i.Id || this.state.index == i.Id) ? "border-bg" : "border-bg-none"}
                                                                autoFocus={this.state.index == i.Id ? true : false}
                                                                id={"actName" + i.Id}
                                                                onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                                                onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChange1(e, i, 'Name', index)}
                                                                onBlur={(e) => this.handleInputChange(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign} `
                                                                }} />
                                                        </div>
                                                        {/* } */}
                                                       {/*  {(i.Name == "") ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Activity Name is required</span> : <></>} */} 
                                                   {/*  </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <div className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-bg" : "border-bg-none"}
                                                        // style={(this.state.HoverId == i.Id || this.state.index == i.Id) ? { marginTop: -4 } : {}}
                                                        >
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                // className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-bg" : "border-bg-none"}
                                                                id={"actDesc" + i.Id}
                                                                onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                                onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                                                autoFocus={(this.state.FocusId == i.Id || this.state.HoverId == i.Id) ? true : false}
                                                                onChange={(e) => this.handleInputChange1(e, i, 'Description')}
                                                                onBlur={(e) => this.handleInputChange(e, i, 'Description')}
                                                                value={i.Description}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                    </td>
                                                    <td className="align-middle text-center border-right"><img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                </tr> : <></>
                                        ))}
                                        {this.state?.dataList.Values && this.state?.dataList.Values.map((i) => (
                                            i.Id == 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        {(i.Name == "") ?
                                                            <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="actName"
                                                                autoFocus={this.state.actNameFocus}
                                                                onFocus={(e) => this.handleFocusActChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChange1(e, i, 'Name')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                onPaste={(e) => this.handlePasteChange(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} /> :
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="actName"
                                                                autoFocus={this.state.actNameFocus}
                                                                onFocus={(e) => this.handleFocusActChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChange1(e, i, 'Name')}
                                                                onPaste={(e) => this.handlePasteChange(e, i, 'Name')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />}
                                                        {((i.Name.trim() == "" && this.state.nameError == true) || (i.Name.trim() == "" && i.Description.trim() != "")) ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Activity Name is required</span> : <></>}
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            id="DescName"
                                                            onFocus={(e) => this.handleFocusDescription(e, i, 'Description')}
                                                            onChange={(e) => this.handleInputChange1(e, i, 'Description')}
                                                            onBlur={(e) => this.postDataBlur(e, i, 'Description')}
                                                            value={i.Description}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                    </td>
                                                    <td className="align-middle text-center border-right">
                                                        {(i.Name.trim() != "" || (i.Name.trim() == "" && this.state.nameError == true)) ? <img src={Delete} className="cursorPointer" /> : <></>}
                                                    </td>
                                                </tr> : <></>
                                        ))}
                                        {this.state.showrow ?
                                            <tr className="border-top">
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>
                                                <td className="align-middle text-center border-right">
                                                </td>
                                            </tr> : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
 */}                  {/*   <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div */} 
                <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.state.dataList?.pagination?.PageCount) || (this.state.dataList?.pagination?.PageCount == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MasterData))
);
